import {Page, NavController, NavParams} from 'ionic-angular';
import {StudyGuidePage} from '../study-guide/study-guide';
import {StudyGuideService} from '../../services/study-guides';


@Page({
  templateUrl: 'build/pages/study-guide-list/study-guide-list.html',
  providers: [StudyGuideService],
})
export class StudyGuideListPage {
  selectedItem:any;
  icons:string[];
  items:Array<{title: string, note: string, icon: string}>;
  guides;

  constructor(private nav:NavController, navParams:NavParams, studyGuideService:StudyGuideService) {
    // If we navigated to this page, we will have an item available as a nav param
    this.selectedItem = navParams.get('item');
    this.guides = studyGuideService.getGuides();
  }

  itemTapped(event, item) {
    this.nav.push(StudyGuidePage, {
      guide: item
    });
  }
}